import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyDultXrjeSRl-VH5rQtleirm_OhUKnW03c",
  authDomain: "vecinos-e38c4.firebaseapp.com",
  projectId: "vecinos-e38c4",
  storageBucket: "vecinos-e38c4.appspot.com",
  messagingSenderId: "513010805738",
  appId: "1:513010805738:web:8718afc1f251e24fb42093",
  measurementId: "G-G95GN5M21B"
};
/*
const firebaseConfigDev = {
    apiKey: 'AIzaSyDp3UX9Ekmv_LquE51j6d2Qvkgt53p9eOs',
    authDomain: 'vecinosdev-d0613.firebaseapp.com',
    projectId: 'vecinosdev-d0613',
    storageBucket: 'vecinosdev-d0613.appspot.com',
    messagingSenderId: '114185402344',
    appId: '1:114185402344:web:56faf12ba7420158b3d65d',
    measurementId: 'G-1XH70XWWSG',
}*/

const app = initializeApp(firebaseConfig)

const auth = getAuth()
auth.languageCode = 'es'

const db = getFirestore(app)

const storage = getStorage(app)

export { auth, db, storage }
